export default {
  loading: false,
  messages: [],
  message: {},
  totalCount: 0,
};
